/**
 * <header-menu> - wraps the hamburger toggle and the collapsible nav
 * dropdown used below 1200px (tablet and mobile - the desktop nav bar
 * doesn't use this at all; see the min-width: 1200px override in
 * header.liquid, which puts the nav back in normal flow and hides the
 * toggle entirely).
 *
 * The toggle and nav are DOM children of this element (not siblings),
 * same lesson as the other custom elements in this theme
 * (traveling-carousel, faq-accordion): a querySelector scoped to `this`
 * finds nothing if the markup nests them outside the custom element tag.
 */
class HeaderMenu extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.nav = this.querySelector('[data-nav]');
    if (!this.toggle || !this.nav) return;

    this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen()));

    this.nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => this.setOpen(false));
    });

    document.addEventListener('click', (event) => {
      if (this.isOpen() && !this.contains(event.target)) {
        this.setOpen(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen()) {
        this.setOpen(false);
        this.toggle.focus();
      }
    });
  }

  isOpen() {
    return this.toggle.getAttribute('aria-expanded') === 'true';
  }

  setOpen(open) {
    this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.nav.classList.toggle('is-open', open);
  }
}

customElements.define('header-menu', HeaderMenu);
